import * as z from "zod";
import { userFacingError } from "../authorization";
import { MODEL_EXPERIMENT_FLAG } from "../featureFlagNames";
import { isFeatureFlagEnabled } from "../featureFlags";
import { assertCanWriteChat } from "./chatAccess";
import { mutator } from "./mutator";

export const recordModelExperimentEventSchema = z.discriminatedUnion("kind", [
  z.object({
    kind: z.literal("feedback"),
    chatId: z.string(),
    model: z.string(),
    feedback: z.enum(["up", "down"]),
  }),
  z.object({
    kind: z.literal("switch"),
    chatId: z.string(),
    model: z.string(),
    fromModel: z.string(),
  }),
]);

// Writes nothing: the server mutator emits telemetry after the transaction
// commits.
export const recordModelExperimentEvent = mutator({
  schema: recordModelExperimentEventSchema,
  resolve: {},
  permissions: {
    none: "write access is checked in fn: the caller’s own personal chat, or a workflow chat in a space they can write",
  },
  fn: async ({ tx, ctx, args }) => {
    if (
      !(await isFeatureFlagEnabled(tx, MODEL_EXPERIMENT_FLAG, ctx.tenantId))
    ) {
      throw userFacingError("The model experiment is not enabled");
    }
    await assertCanWriteChat(tx, ctx, args.chatId);
  },
});
